export const SEGMENT_BG_CLASSES = [
  'bg-primary-500',
  'bg-indigo-400',
  'bg-amber-400',
  'bg-emerald-400',
  'bg-rose-400',
  'bg-sky-400',
  'bg-violet-400',
  'bg-orange-400',
  'bg-teal-400',
  'bg-pink-400'
]

export const SEGMENT_FILL_CLASSES = [
  'bg-primary-500/15',
  'bg-indigo-400/15',
  'bg-amber-400/15',
  'bg-emerald-400/15',
  'bg-rose-400/15',
  'bg-sky-400/15',
  'bg-violet-400/15',
  'bg-orange-400/15',
  'bg-teal-400/15',
  'bg-pink-400/15'
]
